module.exports = __webpack_public_path__ + "zvetseni-prsou_12_before_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/zvetseni-prsou_12_before_tn.jpg
// module id = 1766
// module chunks = 0